<template>
</template>

<script>
	import * as turf from '@turf/turf';

	export default {
		name: 'PathLoader',
		data() {
			return {
				polygons: {}
			}
		},
		computed: {
			pathLayer: {
				get() { return this.$store.state.map.pathLayer; },
				set(value) { this.$store.commit('setState', [ 'map.pathLayer', value]) }
			},
			drawLayer() { return this.$store.state.map.drawLayer },
			paths: {
				get() { return this.$store.state.paths},
				set(value) {
					this.$store.commit('setState', ["paths", value]);
				}
			},
			path_features: {
				get() { return this.$store.state.path_features },
				set(value) { this.$store.commit('set_path_feature', value)}
			},
			roads_vector: {
				get() { return this.$store.state.roads_vector},
				set(value) {
					this.$store.commit('setState', ["roads_vector", value]);
				}
			},
			map() { return this.$store.state.map.map },
			zones() { return this.$store.state.zones},
			features() { return this.$store.state.features },
			location() { return this.$store.state.location}
		},
		mounted() {
			this.pathLayer = new ol.source.Vector({ });
			this.map.addLayer( new ol.layer.Vector({ source: this.pathLayer, style: this.setPathStyle() }) );
			this.roads_vector = new ol.source.Vector();
			this.load();
		},
		methods: {
			load() {

				for (var i in this.paths) {
					var feature = new ol.Feature({
						geometry: new ol.geom.MultiLineString(this.paths[i].coordinates),
					});


					feature.id = this.paths[i].id;
					feature.type = 'path';
					feature.turf = turf.multiLineString(this.$geo.toTurf(this.paths[i].coordinates));

					//this.paths[i].length = feature.getGeometry().getLength();

					this.pathLayer.addFeature(feature);


					this.$set(this.path_features, feature.id, feature);

					this.paths[i].risk = 0;
					this.calculateSafety(feature);
					this.hasStairs(feature);
				}
			},
			calculateSafety(path) {
				for (var i in this.features) {
					var feature = this.features[i];
					if (feature.type != 'restricted') continue;

					var intersects = turf.lineIntersect(path.turf, feature.turf);
					if (intersects.features.length > 0) {
						this.paths[path.id].risk++;
					}
				}
			},
			hasStairs(path) {

				for (var i in this.features) {
					var feature = this.features[i];
					if (feature.type != 'stairs') continue;
					if (this.paths[path.id].hasStairs) continue;

					var intersects = turf.lineIntersect(path.turf, feature.turf);

					if (intersects.features.length > 0) {
						this.paths[path.id].hasStairs = true;
					}
				}
			},
			setPathStyle() {
				if (this.$config.env == 'dev' || this.$config.mode != 'game') return new ol.style.Style({ 'stroke': new ol.style.Stroke({color: 'grey', width:4}) });
				return new ol.style.Style({ zIndex: -1 });
			}
		}
	}
</script>
